import PropTypes from 'prop-types';
import { create } from 'jss';
import rtl from 'jss-rtl';
import { StylesProvider, jssPreset } from '@mui/styles';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

function CustomStylesProvider({ direction, children, generateClassName }) {
  if (direction !== 'rtl') {
    return <StylesProvider generateClassName={generateClassName}>{children}</StylesProvider>;
  }
  return (
    <StylesProvider jss={jss} generateClassName={generateClassName}>
      <div dir="rtl">{children}</div>
    </StylesProvider>
  );
}

CustomStylesProvider.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.string
};

export default CustomStylesProvider;
